import { ComponentProps, FC, ReactNode } from 'react';
import style from './style.module.scss';
import classNames from 'classnames';

interface Props extends ComponentProps<'section'> {
	children: ReactNode;
}

export const Content: FC<Props> = ({ children, className, ...props }) => {
	return (
		<section {...props} className={classNames(style.main, className)}>
			{children}
		</section>
	);
};
